import * as PIXI from "pixi.js";
import TracingPaperRenderer from "./TracingPaperRenderer";
import { rootEventBus, EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "../../managers/EventBus";
import { Coord } from "../../../../../../src/types/Interface";
import getAngleBetweenPoints from "../../../../../../src/utils/math/getAngleBtwPoints";
import RotateAnimation from "./helpers/rotateAnimHelper";
import addInteractivity from "../../../../../../src/utils/addInteractivity";
import { CustomCursorType } from "../../../../../../src/entities/UI/CustomCursor/CustomCursor";


export default class TracingPaper {
  private TracingPaperRenderer = new TracingPaperRenderer();
  private gridCellSize: number = 0;
  private pivotCoord!: Coord;
  private shapeCoords!: Coord[];
  private rotRadian!: number;
  private isPressing!: boolean;
  private startRadian: number = 0;
  private deltaRadian: number = 0;
  private shapeRotation: number = 0;

  constructor(gridCellSize: number) {
    this.gridCellSize = gridCellSize;
    this.addInteractivity();

    rootEventBus.on(EnumRootEventBus.setPointerMove, (c: Coord) => this.handlePointerMove(c));
    rootEventBus.on(EnumRootEventBus.setPointerUp, () => this.handlePointerUp());
    eventBus.on(EnumEventBus.setTracingMode, (v: boolean) => this.handleTracingMode(v));
    eventBus.on(EnumEventBus.animateTracingPaper, (v: boolean) => this.animatePaper(v));
  }
  private handleTracingMode(v: boolean) {
    if (v) { return this.setPaper() }
    this.startRadian = 0;
    this.deltaRadian = 0;
    this.shapeRotation = 0;
    this.TracingPaperRenderer.clearAll();
  }
  async animatePaper(v: boolean) {
    if (v) {
      this.shapeRotation = 0;
      this.deltaRadian = 0;
      await RotateAnimation(this.rotRadian, (r: number) => { this.shapeRotation = r; this.setPaper() })
    }
  }
  setShapeDetails(shapeCoords: Coord[], pivotCoord: Coord, rotRadian: number) {
    this.shapeCoords = shapeCoords;
    this.pivotCoord = pivotCoord;
    this.rotRadian = rotRadian;
    eventBus.emit(EnumEventBus.setTracingMode, false);
  }
  setInteractivity(v: boolean) {
    this.TracingPaperRenderer.setInteractivity(v);
    this.isPressing = !v;
  }
  addInteractivity() {
    const handleDownFunc = (e: PIXI.FederatedPointerEvent) => {
      this.setInteractivity(false);
      this.startRadian = getAngleBetweenPoints(e.global, this.pivotCoord);
    }
    addInteractivity(this.TracingPaperRenderer, { handleDownFunc }, CustomCursorType.grab);
  }
  private handlePointerUp() {
    this.shapeRotation = this.shapeRotation + this.deltaRadian
    this.setInteractivity(true);
  }
  private handlePointerMove(coord: Coord) {
    if (!this.isPressing) { return }

    const radian = getAngleBetweenPoints(coord, this.pivotCoord);
    this.deltaRadian = radian - this.startRadian;
    this.setPaper();
  }
  private setPaper() {
    const totalRotation = this.shapeRotation + this.deltaRadian
    const rotatedBgCoords = this.TracingPaperRenderer.drawBg(this.gridCellSize, [...this.shapeCoords], { ...this.pivotCoord }, totalRotation);
    this.TracingPaperRenderer.drawShape([...this.shapeCoords], { ...this.pivotCoord }, totalRotation);
    this.TracingPaperRenderer.drawPivotPls({ ...this.pivotCoord }, totalRotation);
    this.TracingPaperRenderer.drawRotateSymbol(rotatedBgCoords, totalRotation);
  }
}